import { render, staticRenderFns } from "./CallsinQueue.vue?vue&type=template&id=244aa3e8&scoped=true"
import script from "./CallsinQueue.vue?vue&type=script&lang=js"
export * from "./CallsinQueue.vue?vue&type=script&lang=js"
import style0 from "./CallsinQueue.vue?vue&type=style&index=0&id=244aa3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244aa3e8",
  null
  
)

export default component.exports